import React from 'react';
import propTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import {
  UiInputAdapter,
  UiSelectAdapter,
  AddressPickerAdapter,
  UiFieldset,
  UiToggleAdapter,
} from 'src/ui';
import { ZIP_MASK } from 'src/ui/const';
import { ADDRESS_PREFIX_MAILING, ADDRESS_PREFIX_PRIMARY } from '../const';
import { required } from '../../ui/validations';

export function AddressForm({ statesOptions, prefix, values, className }) {
  const isDisabled = prefix === ADDRESS_PREFIX_MAILING && values.sameAsPrimary;
  const maybeRequired = fieldName => (value, values) =>
    prefix === ADDRESS_PREFIX_MAILING && values.sameAsPrimary
      ? undefined
      : required(fieldName)(value);
  const title =
    prefix === ADDRESS_PREFIX_MAILING ? 'Mailing Address' : 'Home Address';

  return (
    <UiFieldset title={title} isFirst={prefix === ADDRESS_PREFIX_PRIMARY}>
      <Columns isMultiline className={className}>
        {prefix === ADDRESS_PREFIX_MAILING && (
          <Column isSize="full">
            <Field
              component={UiToggleAdapter}
              name="sameAsPrimary"
              id="sameAsPrimary"
              type="checkbox"
            >
              Same as home address?
            </Field>
          </Column>
        )}
        <Column isSize="full">
          <Field
            component={AddressPickerAdapter}
            label="Search Address"
            name={`${prefix}AutocompleteAddress`}
            id={`${prefix}AutocompleteAddress`}
            isDisabled={isDisabled}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${prefix}Address`}
            id={`${prefix}Address`}
            label="Address 1"
            required={!isDisabled}
            disabled={isDisabled}
            validate={maybeRequired('Address 1')}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${prefix}Address2`}
            id={`${prefix}Address2`}
            label="Address 2"
            disabled={isDisabled}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${prefix}City`}
            id={`${prefix}City`}
            label="City"
            required={!isDisabled}
            disabled={isDisabled}
            validate={maybeRequired('City')}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiSelectAdapter}
            name={`${prefix}State`}
            id={`${prefix}State`}
            label="State"
            required={!isDisabled}
            options={statesOptions}
            isDisabled={isDisabled}
            validate={maybeRequired('State')}
            fieldClassName={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${prefix}Zipcode`}
            id={`${prefix}Zipcode`}
            label="Zip Code"
            required={!isDisabled}
            mask={ZIP_MASK}
            disabled={isDisabled}
            validate={maybeRequired('Zip Code')}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
      </Columns>
    </UiFieldset>
  );
}

AddressForm.defaultProps = {
  prefix: ADDRESS_PREFIX_PRIMARY,
  className: '',
};

AddressForm.propTypes = {
  prefix: propTypes.oneOf([ADDRESS_PREFIX_PRIMARY, ADDRESS_PREFIX_MAILING]),
  statesOptions: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      value: propTypes.string.isRequired,
    })
  ).isRequired,
  values: propTypes.object.isRequired,
  className: propTypes.string,
};
